(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ruby-live-catalog"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-ruby-catalog]').forEach(root => {
    if(root.dataset.catalogReady) return;
    root.dataset.catalogReady='true';
    const grid=root.querySelector('[data-catalog-grid]');
    const input=root.querySelector('[data-catalog-search]');
    const button=root.querySelector('[data-catalog-print]');
    const printButton=root.querySelector('[data-catalog-open-print]');
    const status=root.querySelector('[data-catalog-status]');
    const pagination=root.querySelector('[data-catalog-pagination]');
    const messages=JSON.parse(root.querySelector('[data-catalog-messages]').textContent);
    let loading=null, loaded=false, preparing=false, prepared=false;
    const cards=()=>[...grid.querySelectorAll('[data-catalog-card]')];
    const format=(message,count)=>message.replace('[count]',count).replace('[total]',root.dataset.catalogTotal);
    const yieldUI=()=>new Promise(resolve=>setTimeout(resolve,0));
    function filter(){
      const query=input.value.trim().toLocaleLowerCase();
      let found=0;
      cards().forEach(card=>{
        card.hidden=!card.textContent.toLocaleLowerCase().includes(query);
        if(!card.hidden) found++;
      });
      if(!loading&&!preparing) status.textContent=found ? format(messages.ready,found) : messages.none;
    }
    async function loadAll(){
      if(loaded)return;
      if(loading)return loading;
      status.textContent=messages.loading;
      loading=(async()=>{
        const firstPage=new URL(location.href);
        firstPage.searchParams.set('page','1');
        firstPage.hash='';
        let next=firstPage.href;
        const visited=new Set(), known=new Set(cards().map(card=>card.dataset.catalogKey));
        const started=Date.now();
        while(next){
          if(Date.now()-started>60000)throw new Error('Catalog timeout');
          const url=new URL(next,location.href);
          url.searchParams.set('section_id',root.dataset.sectionId);
          if(url.origin!==location.origin||visited.has(url.href))throw new Error('Invalid catalog page');
          visited.add(url.href);
          const controller=new AbortController();
          const timeout=setTimeout(()=>controller.abort(),15000);
          let html;
          try{
            const response=await fetch(url.href,{credentials:'same-origin',signal:controller.signal});
            if(!response.ok)throw new Error('Catalog unavailable');
            html=await response.text();
          }finally{clearTimeout(timeout);}
          const doc=new DOMParser().parseFromString(html,'text/html');
          const remote=doc.querySelector('[data-ruby-catalog]');
          if(!remote)throw new Error('Catalog missing');
          const fragment=document.createDocumentFragment();
          remote.querySelectorAll('[data-catalog-card]').forEach(card=>{
            if(!known.has(card.dataset.catalogKey)){
              known.add(card.dataset.catalogKey);
              fragment.append(card);
            }
          });
          grid.append(fragment);
          status.textContent=format(messages.progress,known.size);
          await yieldUI();
          next=remote.querySelector('[data-catalog-next]')?.getAttribute('href');
        }
        loaded=true;pagination.hidden=true;
      })();
      try{await loading;}finally{loading=null;}
    }
    function waitForImage(img,deadline){
      return new Promise((resolve,reject)=>{
        const remaining=Math.min(8000,deadline-Date.now());
        if(remaining<=0){reject(new Error('Image timeout'));return;}
        let timer;
        const done=error=>{
          clearTimeout(timer);
          img.removeEventListener('load',onLoad);
          img.removeEventListener('error',onError);
          error?reject(error):resolve();
        };
        const onLoad=()=>done(img.naturalWidth?null:new Error('Image missing'));
        const onError=()=>done(new Error('Image unavailable'));
        img.addEventListener('load',onLoad,{once:true});
        img.addEventListener('error',onError,{once:true});
        timer=setTimeout(()=>done(new Error('Image timeout')),remaining);
        img.loading='eager';
        if(img.complete)onLoad();
      });
    }
    async function prepareImages(){
      const images=[...grid.querySelectorAll('img')];
      const deadline=Date.now()+45000;
      let cursor=0, completed=0, failed=0;
      async function worker(){
        while(cursor<images.length){
          if(Date.now()>=deadline)throw new Error('Image timeout');
          const image=images[cursor++];
          try{await waitForImage(image,deadline);}catch(error){failed++;}
          completed++;
          status.textContent=messages.images.replace('[count]',completed).replace('[total]',images.length);
        }
      }
      await Promise.all(Array.from({length:Math.min(12,images.length)},worker));
      if(failed)throw new Error('Image unavailable');
    }
    let timer;
    input.addEventListener('input',()=>{
      clearTimeout(timer);
      timer=setTimeout(async()=>{
        try{await loadAll();filter();}catch(error){status.textContent=messages.error;}
      },250);
    });
    button.addEventListener('click',async()=>{
      if(preparing)return;
      preparing=true;prepared=false;
      button.disabled=true;input.disabled=true;
      printButton.hidden=true;
      input.value='';
      let imagePhase=false;
      try{
        await loadAll();filter();
        imagePhase=true;
        await prepareImages();
        prepared=true;
        printButton.hidden=false;
        status.textContent=messages.print_ready;
        printButton.focus();
      }catch(error){
        status.textContent=imagePhase?messages.image_error:messages.error;
      }finally{
        preparing=false;button.disabled=false;input.disabled=false;
      }
    });
    printButton.addEventListener('click',()=>{
      if(!prepared)return;
      input.value='';filter();
      window.print();
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
